function normalizeBaseUrl(url, fallback = '') {
  return (url || fallback).replace(/\/+$/, '');
}

const envApiMode = (process.env.REACT_APP_API_MODE || '').trim().toLowerCase();
const defaultApiMode = process.env.NODE_ENV === 'production' ? 'remote' : 'local';

export const APP_API_MODE =
  envApiMode === 'local' || envApiMode === 'remote'
    ? envApiMode
    : defaultApiMode;

const LOCAL_APP_API_BASE = normalizeBaseUrl(
  process.env.REACT_APP_API_LOCAL_BASE,
  'http://localhost:3001',
);

const REMOTE_APP_API_BASE = normalizeBaseUrl(
  process.env.REACT_APP_REMOTE_API_BASE ||
    process.env.REACT_APP_LOCAL_API_BASE,
  'https://api.nahooray.com'
);

export const APP_API_BASE =
  APP_API_MODE === 'local' ? LOCAL_APP_API_BASE : REMOTE_APP_API_BASE;

function isLoopbackHost(hostname) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1';
}

export function isRemoteAppApiBase(baseUrl = APP_API_BASE) {
  if (!baseUrl) {
    return false;
  }

  try {
    return !isLoopbackHost(new URL(baseUrl).hostname);
  } catch {
    return false;
  }
}

export function requiresAppApiAuth() {
  return APP_API_MODE === 'remote' || process.env.NODE_ENV === 'production';
}

export function getAppApiLabel() {
  return APP_API_BASE || 'Browser origin / package.json proxy';
}